import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({
    iconName,
    alt,
    width,
    height,
    alignSelf,
    rotate,
    style,
    ...rest
}) => (
    <img
        src={`/assets/${iconName}`}
        alt={alt}
        style={{
            width,
            height,
            alignSelf,
            transform: `rotate(${rotate}deg)`,
            ...style,
        }}
        {...rest}
    />
)

Icon.propTypes = {
    iconName: PropTypes.string.isRequired,
    alt: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    alignSelf: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'stretch',
    ]),
    rotate: PropTypes.number,
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    // Plus all other props associated to native Image comp
}

Icon.defaultProps = {
    alt: 'icon',
    width: 'auto',
    height: 'auto',
    alignSelf: 'flex-start',
    rotate: 0,
    style: {},
}

export default Icon
